module.exports = __webpack_public_path__ + "img/marker_four_red2.02948f7e.png";